import React from "react";
import "./CTFormList.css";


const CTFormList = ({ children, title }) => {
  return (
    <div className="ctformlist-container">
        {children}
     
    </div>
  );
};

export default CTFormList;